module.exports = __webpack_public_path__ + "img/type_40_4.prt.d5f96961.jpg";